import React from "react";
import { styled } from "@mui/material/styles";

type CustomButtonProps = {
  id?: string;
  dataId?: string;
  height?: string;
  width?: string;
  variant: "primary" | "secondary" | "info" | "warning" | "success" | "neutral";
  color?: string;
  onClick?: (event: any) => void;
  disabled?: boolean;
  children: JSX.Element | string;
  type?: "submit" | "button" | "reset";
  margin?: number;
  selected?: boolean;
  locked?: boolean;
};

const Button: React.FC<CustomButtonProps> = ({
  color,
  disabled,
  height,
  variant,
  width,
  children,
  onClick,
  type,
  dataId,
  margin,
  selected,
  locked
}) => {
  const StyledButton = styled("button")(({ theme }) => ({
    background: selected ? theme.palette[variant].main : theme.palette[variant].light,
    color: color || "white",
    height: height || theme.spacing(4),
    width: width,
    padding: theme.spacing(1),
    margin: theme.spacing(margin ? margin : 0),
    border: `solid 1px ${theme.palette[variant].light}`,
    cursor: locked ? "default" : "pointer",
    "&:hover": {
      background: locked
        ? theme.palette[variant].light
        : selected
          ? theme.palette[variant].dark
          : theme.palette[variant].main,
    },
    "&:disabled": {
      background: theme.palette[variant].light,
      opacity: 0.4,
      color: color || "white",
      cursor: "not-allowed",
      borderColor: theme.palette[variant].light
    }
  }));

  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      type={type}
      data-id={dataId}
    >
      {children}
    </StyledButton>
  );
};

export default Button;